import React, { memo } from 'react'
import { Outlet, Navigate } from 'react-router-dom';
import { isAdmin, isProvider } from './common/authentification-functions';

type Props = {}

const GuestOrCustomerGuard: React.FC<Props> = memo((props: Props) => {
    if(isAdmin() || isProvider()){
        return <Navigate to="/login" replace/>
    }
    
    return (
        <Outlet />
    )
})

export default GuestOrCustomerGuard